import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { HIDE_SCROLLBAR_OFFSET_PX } from '../../../common/constants';
import { withSynchronizedScroll } from '../../../common/context';

type APIProps = {
	isScrollable: boolean;
	children: ReactNode;
};

type Props = APIProps;

function ScrollArea(props: Props) {
	const { isScrollable, children } = props;
	return (
		<ScrollBarContainer>
			<SynchronizedScrollbar
				data-testid="deployments.common.components.table.components.list.scroll-area.hidden-scrollbar"
				/* @ts-expect-error - TS2769 - No overload matches this call. */
				isScrollable={isScrollable}
			>
				{children}
			</SynchronizedScrollbar>
		</ScrollBarContainer>
	);
}

ScrollArea.defaultProps = {
	isScrollable: true,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ScrollBarContainer = styled.div({
	display: 'flex',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HiddenScrollbar = styled.div<{ isScrollable: boolean }>({
	flex: '0 0 auto',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	overflowY: ({ isScrollable }) => (isScrollable ? 'auto' : 'hidden'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingRight: HIDE_SCROLLBAR_OFFSET_PX,
});

// @ts-expect-error - TS2345 - Argument of type 'ComponentType<{ isScrollable: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps>' is not assignable to parameter of type 'ComponentType<Props>'.
const SynchronizedScrollbar = withSynchronizedScroll(HiddenScrollbar, {
	syncAxis: 'y',
	isCompiledComponent: true,
});

export default ScrollArea;
